import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { environment } from 'src/environments/environment';
import { CartModuleConsts } from '../../contants';
import { CartService } from '../../services/cart.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SharedConsts } from 'src/app/shared/constants';
import { select, Store } from '@ngrx/store';
import { SharedState } from 'src/app/shared/store/reducers';
import { getConfig } from 'src/app/shared/store/selectors/shared.selectors';

declare let Frames: any;
@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent implements OnInit {
  status: boolean = false;
  redirectUrl:any;
  public windowUrl: any;
  bsModalRef: BsModalRef;
  bsModalRefForError: BsModalRef;
  selectedItem: any;
  gatewayToken:any;
  firstHit: any = 1;
  show: boolean = false;
  orderDetail: any;
  componentLoaded = false;
  allProductCounts: any;
  promotionMessage = [];
  saveCardValue: any;
  global_data:any = {};
  errorMessage = '';
  configDetails = '';
  cardtypes = {'VI': 'Visa', 'AE':'American Express', 'MC':'Mastercard', 'DI':'Discover', 'DN':'Diners Club',
  'JCB':'JCB'}
  cardImages = {'VI': 'vi.svg', 'AE':'ae.svg', 'MC':'mc.svg', 'DI':'di.svg', 'DN':'dn.svg',
  'JCB':'jcb.svg'}
  url: any;
  constructor(private cartService: CartService, private statePersist: StatePersistService,
    private alertService: AlertService, private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router, private titleService: Title,
    private modalService: BsModalService,
    private renderer: Renderer2,
    private el:ElementRef,
    public sanitizer:DomSanitizer, private store:Store<SharedState>) {this.getConfigFromStore() }

  
  getConfigFromStore(){
    const config_store$ = this.store.pipe(select(getConfig));
    config_store$.subscribe(res=>this.configDetails = res)
    }
  newpaymentEvent(){
    document.body.classList.add("saved-payment-box");
    document.body.classList.remove("new-payment-box");
    document.getElementById('savecardpay-button').classList.add('savecard-payment');
    document.getElementById('pay-button').classList.remove('newcard-payment');
}
paymentEvent(){
  document.body.classList.add("new-payment-box");
  document.body.classList.remove("saved-payment-box");
  document.getElementById('pay-button').classList.add('newcard-payment');
  document.getElementById('savecardpay-button').classList.remove('savecard-payment');
}
items: any;

  ngOnInit(): void {
    this.orderDetail = null;
    this.titleService.setTitle(CartModuleConsts.PAYMENT_PAGE_TITLE);
    this.checkoutDetail()
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    if(Object.keys(this.statePersist.configDetails).length == 0){
      this.statePersist.getConfigStatus.subscribe((response:any)=>{    
        if(response){
          this.setcheckout()
          this.statePersist.isConfigSetoStore.next(false);
          
        }
      })
    }
    else{
      this.setcheckout()
      this.statePersist.isConfigSetoStore.next(false);
    }
      window.scrollTo(0, 0)

  }

  setcheckout(){
    let payButton: any;
    setTimeout(() => {
      payButton = document.getElementById("pay-button");
      var form = document.getElementById("payment-form");
      
      var key = this.statePersist.checkoutToken
      setTimeout(function(){ 
        Frames.init(
          
          {
            publicKey: key,
            style: {
              base: {
                color: 'black',
                fontSize: '14px',
              },
              autofill: {
                backgroundColor: 'yellow',
              },
              hover: {
                color: '#5E6567',
              },
              focus: {
                color: '#5E6567',
              },
              valid: {
                color: 'green',
              },
              invalid: {
                color: 'red',
              },
              placeholder: {
                base: {
                  color: 'gray',
                },
                focus: {
                  border: 'solid 1px transparent',
                },
              },
            },
          }
          );
  
          
    
        Frames.addEventHandler(
          Frames.Events.CARD_VALIDATION_CHANGED,
          function (event) {
          
            payButton.setAttribute('disabled', String(!Frames.isCardValid()))
            if (Frames.isCardValid()){
              payButton.removeAttribute("disabled")
            }
            else{
              payButton.setAttribute('disabled', String(!Frames.isCardValid()))
            }
            
          }
        );
    
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          document.getElementById('card-token').setAttribute('value', '')
          document.getElementById('card-bin').setAttribute('value', '')
          Frames.submitCard()
            .then((data) => {
              
              document.getElementById('card-token').setAttribute('value', data.token)
              document.getElementById('card-bin').setAttribute('value', data.bin)
              document.getElementById('submit-savecard').click()
            })
            .catch(function (error) {
              document.getElementById('card-token').setAttribute('value', '')
              document.getElementById('card_bin').setAttribute('value', '')
              payButton.removeAttribute("disabled")
            });
        });
     
       },500);
        }, 500);
  
  }
  
  test(errorTemplate, infoTemplate){
    let token, card_bin;
    token = document.getElementById('card-token').getAttribute('value')
    card_bin = document.getElementById('card-bin').getAttribute('value')
    this.placeOrder('payment_token', token, this.saveCardValue, errorTemplate, infoTemplate, card_bin)
  }

  changeSaveCard(event){
    this.saveCardValue = event.target.checked
  }

  checkoutDetail(){
    this.cartService.checkoutDetail()
    .subscribe(
      response => {
          if (response.status == 2212){
            this.alertService.error(response.response)
          }
          this.orderDetail = response.response
          this.promotionMessage = this.orderDetail.one_free_withten_msg
          this.show = false;
          if(this.orderDetail.items_count != '0' && this.orderDetail.min_cases == ''){
            this.firstHit = 1
          }
          this.cardList()
        },
        error => { }
    )
  }

  cardList(){
    this.cartService.savecardList()
    .subscribe(
      response => {
          this.items = []
          if (response.status == 1181){
            console.log()
          }
          else{
            let cardlist, cardNewList = [];
            cardlist = response.response.cardList;
            this.items = []
            for (let i = 0; i < cardlist.length; i++) {
              cardNewList.push({'value':this.cardtypes[cardlist[i]['type']]+', ending: '+cardlist[i]['card_bin']+', expires: '+cardlist[i]['card_expiry_date'],
              'gateway_token':cardlist[i]['gateway_token'], 'image':this.cardImages[cardlist[i]['type']], 'id':cardlist[i]['gateway_token']})
            }       
            this.items = cardNewList
            
            
            window.scroll({ 
              top: 0, 
              left: 0, 
              behavior: 'smooth' 
            });

          }

          setTimeout(() => {
            if (this.items.length > 0){
              this.paymentEvent()
              if(this.items.length == 1){
                this.selectPaymentCard(0, this.items[0])
              }
            }
            else{
              this.newpaymentEvent()
            }
          }, 1000);          
        },
        error => { }
    )
  }

  removeCard(item){
    this.cartService.removeSaveCard({'gateway_token':item.gateway_token})
    .subscribe(
      response => {
        this.items = this.items.filter(olditem => olditem.id !== item.gateway_token);
        this.alertService.success(response.response)
        },
        error => { }
    )
  }

  selectPaymentCard(card_id, item){

    this.selectedItem = card_id;
    this.gatewayToken = item.gateway_token
    document.getElementById('savecardpay-button').removeAttribute("disabled")
  }

  paymentUsingSaveCard(errorTemplate, infoTemplate){
    this.placeOrder('gateway_token', this.gatewayToken, '', errorTemplate, infoTemplate, '')
  }

  openAouthenticationWindow(){
    window.open(this.redirectUrl);
  }

  openedWindow;

  closeOpenedWindow() {
    this.openedWindow.close();
  }

  detectBrowserName() { 
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  placeOrder(flag, token, savecard, errorTemplate, infoTemplate, card_bin){
    let po_number = this.statePersist.getLocalStorage('po_number')
    var popUp

    if(this.detectBrowserName()=='safari')
    {
      popUp = window.open("", '_blank', 'fullscreen=yes,scrollbars=yes,resizable=no,status=no,location=yes,toolbar=no,menubar=no,width=1800,height=1000,left=600,top=-1000');
    }
    else{
      setTimeout(() => {
        popUp = window.open("", '_blank', 'fullscreen=yes,scrollbars=yes,resizable=no,status=no,location=yes,toolbar=no,menubar=no,width=1800,height=1000,left=600,top=-1000');
      }, 2000);
    }

    
    this.cartService.placeOrder('', flag, token, savecard, '', po_number, false, card_bin)
    .subscribe(
      response => {
        if (response.status == 1161 || response.status ==1153 || response.status == 2215){
          popUp.close();
          this.alertService.error(response.response)
          this.router.navigate(['/'])
        }
        else if (response.status == 1182){
          popUp.close();
          this.errorMessage = response.response;
          this.bsModalRefForError = this.modalService.show(errorTemplate,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
          var form = document.getElementById("payment-form");
          (form as HTMLFormElement).reset();
          var data = document.getElementById('singleIframe').getAttribute('src')
          var data1 = document.getElementById('singleIframe')
          this.saveCardValue = false
          data1.setAttribute('src', data+'')
          document.getElementById('pay-button').setAttribute("disabled", 'true')
        }
        else if (response.status == 403){
          if(this.detectBrowserName()=='safari'){
            popUp.close();
              this.router.navigate(['/'])
          }else{
            setTimeout(() => {
              popUp.close();
              this.router.navigate(['/'])
            }, 500);
          }
          
        }
        else if (response.status == 1157){
          popUp.close()
          this.alertService.error(response.response)
          this.router.navigate(['/'])
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1180){
          popUp.close()
            localStorage.setItem('closeStorInfoMessage', response.response.msg)
            document.getElementById("openclosedStoreInfo").click();
            this.router.navigate(['/'])
            document.body.classList.remove("saved-payment-box");
            document.body.classList.remove("new-payment-box");
        }
       else  if (response.status == 1170){
          popUp.close()
          this.router.navigate(['/'])
          this.statePersist.emitminiCartData('mini cart update')
          this.statePersist.emitoutOfStockData('out of stock update')
          this.statePersist.emitmobileListCountDetails('mobile count change')
          this.statePersist.emitmyCartData('my cart list update')
          this.statePersist.emitOrderDetailData('updae order Deatil')
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
        }
        else if (response.status == 1199){
          popUp.location =response.response

        }
        else{
          this.orderDetail['order_id'] = response.response.order_id
          this.orderDetail['order_date'] = response.response.order_date
          this.orderDetail['grand_total'] = response.response.grand_total 
          this.orderDetail["transaction_payment_id"] = response.response.transaction_payment_id 
          this.orderDetail['transaction_date'] = response.response.transaction_date
          this.orderDetail['price_visibility'] = this.global_data['price_visibility']
          this.orderDetail['card_payment'] = 1
          this.statePersist.setLocalStorage('order-detail', this.orderDetail)
          document.body.classList.remove("saved-payment-box");
          document.body.classList.remove("new-payment-box");
          if (response.response.redirect_url != ''){
           this.bsModalRef = this.modalService.show(infoTemplate,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
            popUp.location =response.response.redirect_url
              
           }
          else{
            this.googleAnalyticsService.eventEmitter(SharedConsts.PLACE_ORDER_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PLACE_ORDER_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
            this.router.navigate(['mycart/order-confirmation'])
          }
          
          
        }
        this.firstHit = ''
        
        },
        error => { }
    )
    

  }

  closeInfoPopup(){
    this.bsModalRef.hide()
    this.router.navigate(['mycart'])
  }

  closeErrorPopup(){
    this.bsModalRefForError.hide()
  }

}
